import * as t from '../types';
import {GET_TUTOR_ONE_2_ONE_REQUEST} from "../types";

const initialState = {
    data: '',
    loading: false,
    error: ''
};

export default function groupParticipantsReducer(state = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case t.GET_PARTICIPANTS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case t.GET_PARTICIPANTS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload.data
            };
        case t.GET_PARTICIPANTS_FAILED:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}
